__turbopack_context__.v({
  "className": "fraunces_5e53e67a-module__RfPrla__className",
  "variable": "fraunces_5e53e67a-module__RfPrla__variable",
});
